import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { catchError, retry } from "rxjs/operators";
import { HistoryData } from "./history";
import { Utilities } from "./utilities";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";
import { ITicket } from "shared/models/ticket.model";

@Injectable()
export class TicketService {

  private action: string = "update";

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
    private historyData: HistoryData,
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
  ) { }

  public getList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Ticket`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Ticket`;
    }
    return this.afDb.list<any>(ref).valueChanges();
  }

  public getActiveListTicket(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Ticket`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Ticket`;
    }
    return this.afDb.list<ITicket>(ref,
      (reference) => reference.orderByChild("state").equalTo(true)
    ).valueChanges();
  }

  public getItem(clientId: string, ticketId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Ticket/${ticketId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Ticket/${ticketId}`;
    }
    return this.afDb.object<any>(ref).valueChanges();
  }

  public createOrEdit(clientId: string, info: any) {
    if (!info.id) {
      info.id = this.utilities.generateRamdomKey();
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Interactivity/Ticket/${info.id}`;
    if (this.utilities.validateEventIdParam(info.eventId)) {
      ref = `Clients/${clientId}/Event/${info.eventId}/Ticket/${info.id}`;
    }

    return new Promise((res, rej) => {
      this.afDb.database
        .ref(ref)
        .set(info)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.ticket, info.id, clientId, info.eventId, info, "Creacion/actualizacion ticket");
          return true;
        })
        .then(() => {
          return res(info.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public generateSingleReport(clientId: string, ticketId: string): Promise<any> {
    return this.http.get(`${ENV.backend}/ticketSingle/${clientId}/${ticketId}`)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error generate report: ", err, "red")]))
      .toPromise();
  }

  public generateGeneralReport(clientId: string): Promise<any> {
    return this.http.get(`${ENV.backend}/reports/tickets/${clientId}`)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error generate report: ", err, "red")]))
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/ticket.service.ts